import { FC, useCallback, useEffect, useState } from 'react';

import { Button, Dropdown } from '@britishcouncil/react-extro-ui';

import { FiChevronDown, FiChevronUp } from 'react-icons/fi';
import styled from '@emotion/styled';

import { APP_NAME } from '@/constants';
import { commonAPI } from '@/store';

type Element = {
  label: string;
  disabled?: boolean;
  href?: string;
  value: string;
};

export const ApplicationSwitcherWrapper: FC = () => {
  const { data: applications, isFetching, isError, isSuccess } = commonAPI.useApplicationGetApplicationsWithAccessQuery();
  const [apps, setApps] = useState<Element[]>([]);
  const [dropdownOpened, setDropdownOpened] = useState(false);

  useEffect(() => {
    if (Array.isArray(applications) && applications.length > 0) {
      const newApps = applications
        .filter((el) => el.name !== APP_NAME && el.hasAccess)
        .map((el) => {
          return {
            value: el.id?.toString(),
            label: el.name,
            href: el.appUrl,
          } as Element;
        });
      setApps(newApps);
    }
  }, [applications]);

  const handleOpen = useCallback((status: boolean) => {
    setDropdownOpened(status);
  }, []);

  return (
    <StyledAppWrapper>
      <Dropdown elements={apps} isLoading={(isFetching || isError) && !isSuccess} onOpen={handleOpen} variant="default">
        <Button color="var(--navigation-header-color)" data-testid="application-switcher-activator" variant="discreet" className="appSwitcherButton">
          {APP_NAME} {dropdownOpened ? <FiChevronUp size={24} /> : <FiChevronDown size={24} />}
        </Button>
      </Dropdown>
    </StyledAppWrapper>
  );
};

const StyledAppWrapper = styled.span`
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  gap: var(--whitespace-medium-responsive, 2.4rem);
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  -webkit-justify-content: flex-end;
  justify-content: flex-end;
  & svg {
    position: absolute;
    margin-left: 8px;
    top: 50%;
    right: -8px;
    transform: translateY(-50%);
  }
  button {
    font-size: 18px;
  }
  ul {
    border: 0;
  }
`;
